import { makeAutoObservable } from 'mobx'
import * as API from '../../service/api/ForgotUpwApi'

class ForgotUpwStore {
  constructor() {
    makeAutoObservable(this)
  }

  checkResetClientUpw = async (data) => {
    return await API.CHECK_RESET_CLIENT_UPW(data)
  }

  resetClientUpw = async (data) => {
    return await API.RESET_CLIENT_UPW(data)
  }
}

export default new ForgotUpwStore()
